import { render, staticRenderFns } from "./RetailTable.vue?vue&type=template&id=4ce8c270&scoped=true"
import script from "./RetailTable.vue?vue&type=script&lang=js"
export * from "./RetailTable.vue?vue&type=script&lang=js"
import style0 from "./RetailTable.vue?vue&type=style&index=0&id=4ce8c270&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce8c270",
  null
  
)

export default component.exports